import React, { useEffect, useMemo, useState } from 'react'
import { FormCol, FormRow } from 'style/styled'
import { Checkbox, Select } from 'components/forms'
import { useTranslation } from 'react-i18next'
import Divider from 'components/Divider'
import Button from 'components/Button'
import { ContentBlock, ExpandableBlocks } from 'components/ContentBlock'
import { FormContainer } from 'components/ProfileSettings/styled'
import { useStatisticShop } from '../hooks/useStatisticShop'
import { DatePeriod } from '../../filterFragments'
import ProfileSettings from 'components/ProfileSettings/ProfileSettings'

export default function Filter() {
	const { filterPrepare, dispatchFilter, customData, dispatchCustomData, statisticsDataReceived } = useStatisticShop()
	const { articleGroups, savedSettings } = customData
	const { called, getStatistics, status } = statisticsDataReceived

	// Should be removed when the issue of receiving an 'ERROR from the server is resolved
	useEffect(() => {
		if(status === 'ERROR') {
			handleSetFilter()
		}
	}, [status])

	const [t] = useTranslation()
	const [expandedId, setExpandedId] = useState(null)
	const selectShopText = useMemo(() => t('common.strings.branch'), [t])
	const selectDaysText = useMemo(() => t('common.dates.days'), [t])
	const { from, to, groupBy } = filterPrepare
	const dateLabel = t('statistic_section.strings.date')

	function handleSetFilter() {
		getStatistics({ variables: { params: filterPrepare } })
		setExpandedId('1')
		const isGroups = savedSettings?.columns && savedSettings?.columns.some(item => item?.groupIndex >= 0)
		if(!isGroups && filterPrepare.groupBy === 'SHOP_DAYS') {
			dispatchCustomData({
				type: 'savedSettings',
				value: { columns: [{ dataField: 'name', groupIndex: 0 }] }
			})
		}
	}
	return (
		<>
			<ExpandableBlocks expandedId={expandedId} onExpand={setExpandedId}>
				<ContentBlock blockId='0' startExpanded={!called} label={t('common.strings.settings')}>
					<FormRow>
						<FormCol xs>
							<Select
								noForm
								label={t('statistic_section.strings.grouped_by')}
								value={groupBy}
								options={[
									{ label: selectShopText, value: 'SHOP' },
									{ label: `${selectShopText}-${selectDaysText}`, value: 'SHOP_DAYS' }
								]}
								onChange={({ value }) => dispatchFilter({ type: 'groupBy', value })}
							/>
						</FormCol>
						<DatePeriod
							value={{ fromDateTime: from, toDateTime: to }}
							onChange={value => dispatchFilter({ value, type: 'datePeriod' })}
							label={dateLabel}
							labelPeriod={{
								from: `${dateLabel} ${t('common.strings.from').toLowerCase()}`,
								to: `${dateLabel} ${t('common.strings.to').toLowerCase()}`
							}}
						/>
						<ProfileSettings onSelectProfile={dispatchCustomData} nameLocalStorage={'statisticsProfiles'} profileData={customData} additionalSaveTypes={{ additionalType1: 'articleGroups' }} articleGroups={articleGroups} />
						<FormContainer>
							<Checkbox
								noForm
								checked={articleGroups}
								onChange={(e) => dispatchCustomData({ type: 'articleGroups', value: e.target.checked })}
								label={t('statistic_section.fields.article_groups')}
							/>
						</FormContainer>
					</FormRow>
					<FormRow>
						<FormCol xs>
							<Button text={t('common.buttons.calculate')} onClick={handleSetFilter}/>
						</FormCol>
					</FormRow>
					<Divider />
				</ContentBlock>
			</ExpandableBlocks>
		</>
	)
}
